import { motion } from 'framer-motion'

// Components
import { Button } from '@tracklib/kit'

// Utils
import { pageVariants } from 'components/interestform/utils'

import commonStyles from 'components/interestform/slides/common.css'
import styles from './welcometotracklib.css'

type WelcomeToTracklibProps = {
  handleSubmit: () => void
}

const WelcomeToTracklib = (props: WelcomeToTracklibProps): JSX.Element => {
  const { handleSubmit } = props

  return (
    <motion.div className={styles.wrapper} initial="initial" animate="in" exit="out" variants={pageVariants}>
      <div className={styles.backgroundWrapper}>
        <div>
          <img src="/static/images/interestform/welcome-background.png" alt="Welcome background" className={styles.backgroundImg} />
        </div>
      </div>

      <div className={styles.contentWrapper}>
        <h1 className={styles.heading}>Welcome to Tracklib - The world&apos;s first and only record store for sampling</h1>
        <div className={commonStyles.subheading}>
          Through Tracklib&apos;s exciting new digital service, we can help you to generate income through downloads and licencing deals, as
          well as providing exposure through our extensive Discovery platform
        </div>
        <div className={commonStyles.textContent}>
          <div className={commonStyles.paragraph}>
            If you&apos;re not already familiar with the details, take a few moments to go through the slides to get a feel for who we are
            and what we can do for you! Otherwise you can skip straight to the form and get things rolling!
          </div>
        </div>
        <Button className={styles.nextBtn} onClick={() => handleSubmit()}>
          Let`&apos;s begin
        </Button>
      </div>
    </motion.div>
  )
}

export default WelcomeToTracklib
